import { AccountProfileLoader } from "@/features/user/components/account-profile-loader";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account/_auth")({
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) return;
    if (!context.auth.userData) {
      throw redirect({ to: "/account" });
    }
  },
  component: AuthAccountLayout
});

function AuthAccountLayout() {
  return (
    <>
      <AccountProfileLoader />
      <Outlet />
    </>
  );
}
